import { useRef } from 'react';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent } from 'ag-grid-community';

export default function useExportBloodDrawsOutsideWindow() {
    const gridApiRef = useRef<GridApi>(null);
    const columnApiRef = useRef<ColumnApi>(null);

    const onGridReady = (e: GridReadyEvent) => {
        gridApiRef.current = e.api;
        columnApiRef.current = e.columnApi;
    };

    const exportBloodDrawsOutsideWindow = () => {
        if (!gridApiRef.current) return;

        const params: CsvExportParams = {
            columnKeys: [
                'rank',
                'swap',
                'donorCenterAlias',
                'donorAlias',
                'recipientCenterAlias',
                'recipientAlias',
                'bloodDrawDate',
                'kidneyPickupDate',
                'delta'
            ],
            fileName: 'blood-draws-outside-window.csv'
        };

        gridApiRef.current.exportDataAsCsv(params);
    };

    return { onGridReady, exportBloodDrawsOutsideWindow };
}
